import { FunctionComponent } from "react";

import { Stack, Text } from "@bps/fluent-ui";

export interface InvalidRequestProps {
  description?: string;
  helpText?: string;
}

export const InvalidRequest: FunctionComponent<InvalidRequestProps> = ({
  description,
  helpText
}) => {
  return (
    <Stack horizontalAlign="center" verticalAlign="center" verticalFill grow>
      <Text variant="xLarge" styles={{ root: { textAlign: "center" } }}>
        {description}
      </Text>
      <Text
        variant="medium"
        styles={{
          root: { textAlign: "center", paddingTop: 16, maxWidth: 348 }
        }}
      >
        {helpText}
      </Text>
    </Stack>
  );
};
